import { getPmtTranslations } from '@/fetchers/pmtTranslations.fetchers';
import type { LanguageCode } from '@/interfaces';
import { getMasterTranslationLanguageCode } from './language.utils';

const delay = async (ms: number): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
};

const RETRY_TIME = 3;
const WAITING_TIME = 1000;

export const fetchTranslationsData = async (
  languageCode: LanguageCode,
  retry = RETRY_TIME,
): Promise<Record<string, string>> => {
  const lang = getMasterTranslationLanguageCode(languageCode);
  try {
    const translationsData = await getPmtTranslations(lang);
    return translationsData || {};
  } catch (error) {
    if (retry > 0) {
      await delay(WAITING_TIME);
      return fetchTranslationsData(languageCode, retry - 1);
    }

    console.error(`getPmtTranslationsData failed, reached retry limitation: ${RETRY_TIME}`, error);
    return {};
  }
};
